// removed by extract-text-webpack-plugin
module.exports = {"Timings":"_D4CNL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/UI/Mobile/Tuple/Timings/Timings.scss
// module id = 721
// module chunks = 0